module.exports = __webpack_public_path__ + "img/size2.4d716f2d.png";